import { render, staticRenderFns } from "./InternalNotes.vue?vue&type=template&id=c991bb74&scoped=true&"
import script from "./InternalNotes.vue?vue&type=script&lang=ts&"
export * from "./InternalNotes.vue?vue&type=script&lang=ts&"
import style0 from "./InternalNotes.vue?vue&type=style&index=0&id=c991bb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c991bb74",
  null
  
)

export default component.exports